import xws from 'api/xws/';
import {
  SET_PACKAGES,
  CLEAR_PACKAGES,
  SET_EXACT_MILEAGE_FLAG
} from './actionTypes';
import { ERROR_PACKAGES } from 'store/reducers/errors/actionTypes';

// Selectors
import {
  getVariant,
  getMileageUnit,
  getCappedPricing,
  getDisplayPackages
} from 'store/reducers/dealerSettings/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';
import {
  getRegDate,
  getServicePoint
} from 'store/reducers/appointment/selectors';
import { getWebkey } from 'store/reducers/queryParams/selectors';
import {
  getServicePackage,
  getExactMileageFlag
} from 'store/reducers/packages/selectors';
import { getDrivingCondition } from 'store/reducers/trims/selectors';
import { getReadOnlyPackage } from 'store/reducers/quoteAppt/selectors';

// Actions
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';
import { setMenuType } from 'store/reducers/deeplink/actions';
import { updateApptServicePoint } from 'store/reducers/appointment/actions';
import { setReadOnlyPackage } from 'store/reducers/quoteAppt/actions';

// Constants
import { getService } from 'constants/ajax';

// Shapes
import { customerVehicleShape } from 'utils/shape/customerVehicle';

const setPackages = packagesInfo => ({
  type: SET_PACKAGES,
  payload: packagesInfo
});

const retrievePackages = packageMileage => async (dispatch, getState) => {
  const {
    tokenId,
    appointment: { vehicle }
  } = getState();
  const {
    make,
    year,
    model,
    metaVehicleId,
    transmission,
    transmissionType,
    mileage,
    licenseNumber,
    personId,
    vehicleId,
    ...vehicleInfo
  } = customerVehicleShape(vehicle);
  if (getDisplayPackages(getState())) {
    try {
      const packageService = getService('packages');
      const drivingCondition = getDrivingCondition(getState());
      const webkey = getWebkey(getState());
      packageService.setPathVars({ webkey, make, year, model });
      packageService.setCallBacks(dispatch(ajaxCallbacks()));
      const useExactMileageFlag = getExactMileageFlag(getState());
      const {
        data: { success, statusCode, ...packagesInfo }
      } = await xws(packageService).get(packageService.getPath(), {
        params: {
          ...vehicleInfo,
          drivingCondition,
          mileage: packageMileage || mileage,
          transmissionType: transmission || transmissionType,
          locale: getLocaleCode(getState()),
          authId: tokenId,
          variant: getVariant(getState()),
          units: getMileageUnit(getState()),
          isCappedPricing: getCappedPricing(getState()),
          regDate: getRegDate(getState()),
          useExactMileage: useExactMileageFlag
        }
      });
      const defaultServicePoint =
        packagesInfo.servicePoints.find(({ position }) => position === 1) &&
        packagesInfo.servicePoints.find(({ position }) => position === 1)
          .menuTypes;
      const previousServicePoint =
        packagesInfo.servicePoints.find(({ position }) => position === 0) &&
        packagesInfo.servicePoints.find(({ position }) => position === 0)
          .menuTypes;
      const nextServicePoint =
        packagesInfo.servicePoints.find(({ position }) => position === 2) &&
        packagesInfo.servicePoints.find(({ position }) => position === 2)
          .menuTypes;
      if (!defaultServicePoint) {
        packagesInfo.servicePoints.find(
          ({ position }) => position === 1
        ).position = -1;
        if (previousServicePoint) {
          packagesInfo.servicePoints.find(
            ({ position }) => position === 0
          ).position = 1;
        } else {
          packagesInfo.servicePoints.find(
            ({ position }) => position === 0
          ).position = -1;
          if (nextServicePoint) {
            packagesInfo.servicePoints.find(
              ({ position }) => position === 2
            ).position = 1;
          } else {
            packagesInfo.servicePoints.find(
              ({ position }) => position === 2
            ).position = -1;
          }
        }
      }
      return packagesInfo;
    } catch (e) {
      /* eslint-disable no-console */
      dispatch({
        type: ERROR_PACKAGES,
        payload: true
      });
      console.error(e);
      return {
        servicePoints: []
      };
      /* eslint-enable no-console */
    }
  }
  return {
    servicePoints: []
  };
};

export const getPackages = packageMileage => async (dispatch, getState) => {
  if (getServicePackage(getState())) {
    return;
  }
  const packagesInfo = await dispatch(retrievePackages(packageMileage));
  dispatch(setPackages(packagesInfo));
  if (packagesInfo.servicePoints) {
    dispatch(
      setMenuType(
        packagesInfo.servicePoints.find(({ position }) => position === 1)
      )
    );
  }
};

/**
 * When an appointment is retrieved, the info of the selected package is not
 * complete (there are some properties missing), this method updates the info
 * of the package by querying exactly the same service point
 */
export const updatePackageInfo = () => async (dispatch, getState) => {
  const selectedServicePoint = getServicePoint(getState());
  if (!selectedServicePoint) {
    return;
  }
  const { menuType, ...servicePoint } = selectedServicePoint;
  const services = [];
  const mileage = servicePoint.mileage;
  const packagesInfo = await dispatch(retrievePackages(mileage));
  if (packagesInfo.servicePoints) {
    packagesInfo.servicePoints.forEach(servPoint => {
      if (servPoint.menuTypes) {
        servPoint.menuTypes.forEach(menType => {
          if (menuType.name === menType.name && mileage === servPoint.mileage) {
            if (menType.services) {
              menType.services.forEach(service => {
                const findService = menuType.services.find(
                  ({ id }) => id === service.id
                );
                if (findService) {
                  services.push({ ...findService, ...service });
                }
              });
            }
          }
        });
      }
    });
    if (packagesInfo.servicePoints.length > 0) {
      dispatch(setPackages(packagesInfo));
    }
    if (services.length > 0) {
      dispatch(
        updateApptServicePoint({
          ...servicePoint,
          menuType: { ...menuType, services }
        })
      );
    }
  }
};

export const clearPackages = () => {
  return {
    type: CLEAR_PACKAGES
  };
};
export const setExactMileageFlag = exactMileageFlag => {
  return {
    type: SET_EXACT_MILEAGE_FLAG,
    payload: exactMileageFlag
  };
};

export const updateReadOnlyPackage = selected => async (dispatch, getState) => {
  const readOnlyPackage = getReadOnlyPackage(getState());
  const updatedQuotePackage = {
    ...readOnlyPackage,
    selected
  };
  dispatch(setReadOnlyPackage(updatedQuotePackage));
};



// WEBPACK FOOTER //
// ./src/store/reducers/packages/actions.js